import React from 'react';
import { PatientECGPlotCell, AvatarCell } from 'components';
import { PatientTableItem } from 'types/types';
import { GridCellParams, GridColDef } from '@mui/x-data-grid';
import {
  getPatientAgeFilters,
  getPatientAssessmentFilters,
  getPatientECGFilters,
  getPatientEthnicityFilters,
  getPatientGenderFilters,
} from 'utils';

export const COLUMNS: GridColDef[] = [
  {
    field: 'avatar',
    headerName: 'Avatar',
    width: 80,
    renderCell: (params: GridCellParams<PatientTableItem>) => <AvatarCell {...params.row} size={50} />,
    sortable: false,
    filterable: false,
  },
  {
    field: 'fullName',
    headerName: 'Full Name',
    flex: 1,
    minWidth: 150,
    maxWidth: 200,
    filterable: false,
  },
  {
    field: 'role',
    headerName: 'Role',
    width: 75,
    filterable: false,
  },
  {
    field: 'gender',
    headerName: 'Gender',
    width: 100,
    filterOperators: getPatientGenderFilters(),
  },
  {
    field: 'age',
    headerName: 'Age',
    minWidth: 50,
    filterOperators: getPatientAgeFilters(),
  },
  {
    field: 'ethnicity',
    headerName: 'Ethnicity',
    minWidth: 50,
    filterOperators: getPatientEthnicityFilters(),
  },
  {
    field: 'assessment',
    headerName: 'Last waveform assessment',
    minWidth: 50,
    flex: 1,
    sortable: false,
    filterOperators: getPatientAssessmentFilters(),
  },
  {
    field: 'email',
    headerName: 'Email',
    flex: 1,
    minWidth: 50,
    filterable: false,
  },
  {
    field: 'waveform',
    headerName: 'Last waveform',
    flex: 1,
    minWidth: 250,
    filterOperators: getPatientECGFilters(),
    renderCell: (params: GridCellParams<PatientTableItem>) => <PatientECGPlotCell {...params.row} />,
  },
];

export const INITIAL_PAGE_SIZE = 10;
